export const credentialsPathPatterns = {
  list: "/customers/:customerId/organizations/:organizationId/:sport/credentials",
  create: "create",
  import: "import",
  info: ":credentialId/info",
  edit: ":credentialId/edit",
} as const;
